import { createContext, useContext } from 'react';
import en from './en.json';
import ko from './ko.json';

export type Locale = 'en' | 'ko';
type Translations = Record<string, string>;

const TRANSLATIONS: Record<Locale, Translations> = { en, ko };

export interface I18nContext {
  locale: Locale;
  setLocale: (l: Locale) => void;
  t: (key: string) => string;
}

export function createTranslator(locale: Locale): (key: string) => string {
  const translations = TRANSLATIONS[locale];
  return (key: string) => translations[key] ?? TRANSLATIONS.en[key] ?? key;
}

export const I18nCtx = createContext<I18nContext>({
  locale: 'en',
  setLocale: () => {},
  t: createTranslator('en'),
});

export function useTranslation() {
  return useContext(I18nCtx);
}
